/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 16.08.2016.
 */

import Npvr from './reducer-npvr';

export default Npvr;



// WEBPACK FOOTER //
// ./src/reducers/npvr/index.js